const setGeneralTagDataAction = (state, {payload = {}} = {}) => ({
  ...state,
  ...payload,
});

export default setGeneralTagDataAction;
